<template>
  <div>
    <!-- 表示するべきBookGroup, myLimitedExpressTicketsが一つもなければ ”所持しているチケットがありません”-->
    <FacePhraseForIndexPage
      v-if="
        bookGroups.length == 0 &&
        myLimitedExpressTickets.length == 0 &&
        dbsReports.length == 0
      "
      phrase="所持している過去のチケットがありません"
    />

    <div v-else>
      <!-- 特急券一覧 -->
      <div
        v-for="(limitedExpressTicket, index) in myLimitedExpressTickets"
        :key="index"
      >
        <MFITTResevationCard
          :limited-express-ticket="limitedExpressTicket"
          :is-on-past-page="true"
        />
      </div>

      <!-- チケット一覧 -->
      <TheBookGroupsIndex :is-used-status="true" />

      <!-- シェアサイクル利用レポート一覧 -->
      <div v-for="(dbsReport, index) in dbsReports" :key="index">
        <DbsReports v-if="dbsReport.end_time" :dbs-report="dbsReport" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "TemplateMyTicketsIndexOfPast",
  setup() {
    const store = useStore();
    const bookGroups = computed(() => store.getters["ticketing/bookGroups"]);
    const myLimitedExpressTickets = computed(
      () => store.getters["MFITT/myLimitedExpressTickets"]
    );
    const dbsReports = computed(() => store.getters["dbs/reports"]);

    return {
      bookGroups,
      myLimitedExpressTickets,
      dbsReports,
    };
  },
};
</script>
